// useLoadingEffect.ts
import { useEffect } from "react";

export function useLoadingEffect(isLoading: boolean) {
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
      window.scrollTo(0, 0);
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isLoading]);
}
